import { Component, DestroyRef, Input, OnInit, Signal, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { FormPropsSignal, FormToSignalsService } from '../form-to-signal.service';

export class UtilExampleForm {
    type = new FormControl<string | null>(null, { nonNullable: true });
    id = new FormControl<number | null>(-1, { nonNullable: true });
}

export type UtilExampleFormType = {
    type: string;
    id: number;
};
@Component({
    selector: 'r1-compass-lib-child-comp',
    imports: [CommonModule],
    providers: [FormToSignalsService],
    templateUrl: './child-comp.component.html',
    styleUrl: './child-comp.component.scss',
})
export class ChildCompComponent implements OnInit {
    readonly #formToSignalUtil = inject(FormToSignalsService);
    readonly #destroy = inject(DestroyRef);

    @Input({ required: true })
    form!: FormArray<FormGroup<UtilExampleForm>>;
    formPropertiesSignal: Signal<FormPropsSignal<UtilExampleFormType[]>> = this.#formToSignalUtil.formSignal;

    fieldsFrominstall: UtilExampleFormType[] = [
        { type: 'A', id: 1 },
        { type: 'B', id: 2 },
    ];

    formValsAppendStuff: Signal<UtilExampleFormType[]> = computed(() =>
        this.formPropertiesSignal().value.map(val => {
            const { type } = val;
            return { ...val, type: type ? type + ' stuff' : '' } as UtilExampleFormType;
        })
    );

    /**
     * @description Signal that is `computed` from the form's signal which is set on init
     */
    formTypesComputed: Signal<string[]> = computed(() =>
        this.formPropertiesSignal().value.map(thingItem => {
            const id = thingItem.id;
            if (id) {
                const matchingInstallRecord = this.fieldsFrominstall.find(field => field.id === id);
                return matchingInstallRecord?.type ?? '';
            } else {
                return '';
            }
        })
    );

    ngOnInit() {
        this.#formToSignalUtil.formPropsToSignal(this.form, this.#destroy);
    }
}
